// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"6a4acb43","171":"4eb976c1","374":"2a6c9ffc","466":"f742f646","488":"ee870f65","507":"c9ce5d3e","818":"4dfff046","949":"2e7dd425"}[chunkId] + ".chunk.js";
};